module.exports = __webpack_public_path__ + "millennium-logo.svg?a56234673da80f501955bf272f6b9212";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/millennium-logo.svg
// module id = 108
// module chunks = 0